export default "__VITE_ASSET__DBUCEAmU__"